(function () {
    'use strict';

    angular
        .module('recomActionPlanUpdateStatusAssessRoutes', [
            'recomActionPlanUpdateStatusAssessControllers'
        ])
        .config(router);

    router.$inject = ['$stateProvider', 'historyCtxtServiceProvider'];

    function router($stateProvider, historyCtxtServiceProvider) {
        $stateProvider

            .state('recomActionPlanUpdateStatusAssess', {
                url: '/RecomActionPlanUpdateStatus/User@{ItemPersonID:int}/{BusinessUnitCode:string}',
                resolve: {
                    bUnit: ['$stateParams', 'recomService', function ($stateParams, service) {
                        return service.getBusinessUnitByCode($stateParams.BusinessUnitCode);
                    }],
                    govProcess: ['bUnit', 'recomService', function (bUnit, service) {
                        return service.getActiveGovernanceProcessByRecomBusinessUnit(bUnit.RecomBusinessUnitID);
                    }],
                },
                views: {
                    '': {
                        template: '<div ui-view="mainContent" class="initiative-update-status" autoscroll="true"></div>',
                    },
                    'mainContent@recomActionPlanUpdateStatusAssess': {
                        controller: 'RecomActionPlanUpdateStatusAssessController'
                    }
                }
            })

            .state('recomActionPlanUpdateStatusAssess.noActiveProcess', {
                url: '/NoActiveProcess',
                views: {
                    'mainContent@recomActionPlanUpdateStatusAssess': {
                        templateUrl: require('./assessNoActiveProcess.tpl.html'),
                    }
                }
            })

            .state('recomActionPlanUpdateStatusAssess.actionPlans', {
                resolve: {
                    actionPlansByAssessor: ['$stateParams', 'bUnit', 'recomActionPlanUpdateStatusService', function ($stateParams, bUnit, service) {
                        return service.getActionPlanAssessmentsByAssessor(bUnit.RecomBusinessUnitID, $stateParams.ItemPersonID);
                    }],
                },
                views: {
                    'mainContent@recomActionPlanUpdateStatusAssess': {
                        controller: 'RecomUpdateStatusAssessActionPlansListController'
                    }
                }
            })

            .state('recomActionPlanUpdateStatusAssess.actionPlans.welcome', {
                url: '/Welcome',
                views: {
                    'mainContent@recomActionPlanUpdateStatusAssess': {
                        templateUrl: require('./welcome.tpl.html'),
                        controller: 'RecomUpdateStatusAssessActionPlansListController'
                    }
                }
            })

            .state('recomActionPlanUpdateStatusAssess.actionPlans.completed', {
                url: '/Completed',
                views: {
                    'mainContent@recomActionPlanUpdateStatusAssess': {
                        templateUrl: require('./completed.tpl.html'),
                        controller: 'RecomUpdateStatusAssessActionPlansListController'
                    }
                }
            })

           .state('recomActionPlanUpdateStatusAssess.actionPlans.byActionPlanCriterias', {
               url: '/ActionPlan/{ActionPlanID:int}/Criterias',
               resolve: {
                   assessmentsByActionPlan: ['$stateParams', 'bUnit', 'recomActionPlanUpdateStatusService', function ($stateParams, bUnit, service) {
                       return service.getAssessmentsByAssessorAndActionPlan(bUnit.RecomBusinessUnitID, $stateParams.ItemPersonID, $stateParams.ActionPlanID);
                   }],
                   fiscalYearQuarterKeys: ['assessmentsByActionPlan', function (assessmentsByActionPlan) {
                       var fiscalYearQuarterKeys = _.chain(assessmentsByActionPlan.ActionPlanCriteriaAssessments)
                           .map(function (critAssess) {
                               return critAssess.ActionPlanCriteria.TargetFiscalYearAndQuarter;
                           })
                           .uniq()
                           .value();

                       return fiscalYearQuarterKeys;
                   }]
               },
               views: {
                   'mainContent@recomActionPlanUpdateStatusAssess': {
                       controller: 'RecomUpdateStatusAssessByActionPlanCriteriasController',
                       templateUrl: require('./byActionPlanCriterias.tpl.html')
                   }
               }
           })

            .state('recomActionPlanUpdateStatusAssess.actionPlans.byActionPlanCriteriasByQuarter', {
                url: '/ActionPlan/{ActionPlanID:int}/Criterias/Quarter/{FiscalYearQuarterKey}',
                params: {
                    toPrevious: { value: undefined },
                    toNext: { value: undefined }
                },
                views: {
                    'mainContent@recomActionPlanUpdateStatusAssess': {
                        templateUrl: require('./byQuarter.tpl.html'),
                        controller: 'RecomUpdateStatusAssessByQuarterController',
                        resolve: {
                            assessmentsByActionPlan: ['$stateParams', 'bUnit', 'recomActionPlanUpdateStatusService', function ($stateParams, bUnit, service) {
                                return service.getAssessmentsByAssessorAndActionPlan(bUnit.RecomBusinessUnitID, $stateParams.ItemPersonID, $stateParams.ActionPlanID);
                            }],
                            fiscalYearQuarterKeys: ['assessmentsByActionPlan', function (assessmentsByActionPlan) {
                                var fiscalYearQuarterKeys = _.chain(assessmentsByActionPlan.ActionPlanCriteriaAssessments)
                                    .map(function (critAssess) {
                                        return critAssess.ActionPlanCriteria.TargetFiscalYearAndQuarter;
                                    })
                                    .uniq()
                                    .value();

                                return fiscalYearQuarterKeys;
                            }],
                            criteriaAssessmentsByQuarter: ['$stateParams', 'assessmentsByActionPlan', function ($stateParams, assessmentsByActionPlan) {
                                return _.filter(assessmentsByActionPlan.ActionPlanCriteriaAssessments, {
                                    ActionPlanCriteria: { TargetFiscalYearAndQuarter: $stateParams.FiscalYearQuarterKey }
                                });
                            }]
                        }
                    }
                },
            })

            .state('recomActionPlanUpdateStatusAssess.actionPlans.byActionPlanNoCriterias', {
                url: '/ActionPlan/{ActionPlanID:int}/NoCriteria',
                resolve: {
                    assessmentsByActionPlan: ['$stateParams', 'bUnit', 'recomActionPlanUpdateStatusService', function ($stateParams, bUnit, service) {
                        return service.getAssessmentsByAssessorAndActionPlan(bUnit.RecomBusinessUnitID, $stateParams.ItemPersonID, $stateParams.ActionPlanID);
                    }],
                    fiscalYearQuarterKeys: [function () {
                        return [];
                    }]
                },
                views: {
                    'mainContent@recomActionPlanUpdateStatusAssess': {
                        controller: 'RecomUpdateStatusAssessByActionPlanCriteriasController',
                        templateUrl: require('./byActionPlanNoCriterias.tpl.html'),
                    }
                }
            })

            .state('recomActionPlanUpdateStatusAssess.actionPlans.byActionPlanAssessment', {
                url: '/ActionPlan/{ActionPlanID:int}',
                views: {
                    'mainContent@recomActionPlanUpdateStatusAssess': {
                        templateUrl: require('./byActionPlan.tpl.html'),
                        controller: 'RecomUpdateStatusAssessByActionPlanController',
                        resolve: {
                            assessmentsByActionPlan: ['$stateParams', 'bUnit', 'recomActionPlanUpdateStatusService', function ($stateParams, bUnit, service) {
                                return service.getAssessmentsByAssessorAndActionPlan(bUnit.RecomBusinessUnitID, $stateParams.ItemPersonID, $stateParams.ActionPlanID);
                            }],
                            fiscalYearQuarterKeys: ['assessmentsByActionPlan', function (assessmentsByActionPlan) {
                                var fiscalYearQuarterKeys = _.chain(assessmentsByActionPlan.ActionPlanCriteriaAssessments)
                                    .map(function (critAssess) {
                                        return critAssess.ActionPlanCriteria.TargetFiscalYearAndQuarter;
                                    })
                                    .uniq()
                                    .value();

                                return fiscalYearQuarterKeys;
                            }],
                        }
                    }
                }
            })

         
    }
})();